import { Permissions } from "@/type/api";
import {
  ACCOUNTING_ROLES,
  ACTION_KEYS,
  MODULE_KEYS,
  SALES_ACCOUNTING_ROLES,
  PAGE_KEYS,
  USERS_ADMIN_ROLES,
  WHATSAPP_ROLES,
} from "./keys";
import type { AppModuleDefinition } from "./types";

export const adminModules: AppModuleDefinition[] = [
  {
    key: MODULE_KEYS.AUDIT,
    label: "Audit",
    labelKey: "alkokh.sidebar.audit",
    icon: "tabler-shield-search",
    fallbackRoles: [Permissions.Auditor, ...ACCOUNTING_ROLES],
    nav: { order: 100, titleKey: "alkokh.sidebar.audit", icon: "tabler-shield-search" },
    pages: [
      { key: PAGE_KEYS.AUDIT_SYSTEM, label: "System Audit", labelKey: "alkokh.sidebar.systemAudit", doctype: "Activity Log", paths: ["/audit/system"], pathPrefixes: ["/audit/system/"], fallbackRoles: [Permissions.Auditor, ...ACCOUNTING_ROLES], nav: { titleKey: "alkokh.sidebar.systemAudit", icon: "tabler-shield-check", order: 10, to: { path: "/audit/system" } } },
      { key: PAGE_KEYS.AUDIT_RECORD_HISTORY, label: "Record History", labelKey: "alkokh.sidebar.recordHistory", doctype: "Version", paths: ["/audit/record-history"], pathPrefixes: ["/audit/record-history/"], fallbackRoles: [Permissions.Auditor, ...ACCOUNTING_ROLES], nav: { titleKey: "alkokh.sidebar.recordHistory", icon: "tabler-history", order: 20, to: { path: "/audit/record-history" } } },
      { key: PAGE_KEYS.AUDIT_SETTLEMENT_DIFFERENCES, label: "Settlement Differences", labelKey: "alkokh.sidebar.settlementDifferences", doctype: "Pet App Cashier Settlement", paths: ["/audit/settlement-differences"], pathPrefixes: ["/audit/settlement-differences/"], fallbackRoles: [Permissions.Auditor, ...ACCOUNTING_ROLES], nav: { titleKey: "alkokh.sidebar.settlementDifferences", icon: "tabler-scale", order: 30, to: { path: "/audit/settlement-differences" } } },
    ],
  },
  {
    key: MODULE_KEYS.USERS,
    label: "Users",
    labelKey: "alkokh.sidebar.users",
    icon: "tabler-users",
    fallbackRoles: USERS_ADMIN_ROLES,
    nav: { order: 110, titleKey: "alkokh.sidebar.users", icon: "tabler-users" },
    pages: [
      { key: PAGE_KEYS.USERS_ROLES, label: "System Users", labelKey: "alkokh.sidebar.systemUsers", doctype: "User", paths: ["/roles"], routeNames: ["roles"], fallbackRoles: USERS_ADMIN_ROLES, nav: { titleKey: "alkokh.sidebar.systemUsers", icon: "tabler-user-cog", order: 10, to: { name: "roles" } } },
      { key: PAGE_KEYS.USERS_PROFILE, label: "User Performance Profile", labelKey: "alkokh.adminUserProfile.title", doctype: "User", pathPrefixes: ["/users/"], routeNames: ["users-id-profile"], fallbackRoles: USERS_ADMIN_ROLES },
      { key: PAGE_KEYS.USERS_ACCESS_DESIGNER, label: "Access Designer", labelKey: "alkokh.sidebar.accessDesigner", doctype: "User", paths: ["/access-designer"], routeNames: ["access-designer"], fallbackRoles: USERS_ADMIN_ROLES, nav: { titleKey: "alkokh.sidebar.accessDesigner", icon: "tabler-layout-grid", order: 20, to: { name: "access-designer" } } },
      { key: PAGE_KEYS.USERS_PERMISSIONS, label: "Access Management", labelKey: "alkokh.sidebar.accessManagement", doctype: "Role Profile", paths: ["/permission"], routeNames: ["permission"], fallbackRoles: USERS_ADMIN_ROLES, nav: { titleKey: "alkokh.sidebar.accessManagement", icon: "tabler-shield-lock", order: 30, to: { name: "permission" } } },
    ],
    actions: [
      { key: ACTION_KEYS.USERS_PERMISSIONS_CREATE, label: "Create access profiles", labelKey: "Create access profiles", pageKey: PAGE_KEYS.USERS_PERMISSIONS, fallbackRoles: USERS_ADMIN_ROLES },
      { key: ACTION_KEYS.USERS_PERMISSIONS_UPDATE, label: "Update access profiles", labelKey: "Update access profiles", pageKey: PAGE_KEYS.USERS_PERMISSIONS, fallbackRoles: USERS_ADMIN_ROLES },
      { key: ACTION_KEYS.USERS_PERMISSIONS_DELETE, label: "Delete access profiles", labelKey: "Delete access profiles", pageKey: PAGE_KEYS.USERS_PERMISSIONS, fallbackRoles: USERS_ADMIN_ROLES },
      { key: ACTION_KEYS.USERS_PERMISSIONS_EXPORT, label: "Export access profiles", labelKey: "Export access profiles", pageKey: PAGE_KEYS.USERS_PERMISSIONS, fallbackRoles: USERS_ADMIN_ROLES },
      { key: ACTION_KEYS.USERS_PERMISSIONS_PRINT, label: "Print access profiles", labelKey: "Print access profiles", pageKey: PAGE_KEYS.USERS_PERMISSIONS, fallbackRoles: USERS_ADMIN_ROLES },
    ],
    shortcuts: [
      { icon: "tabler-user-plus", title: "System Users", subtitle: "Create and edit users", to: { name: "roles" }, accessKey: PAGE_KEYS.USERS_ROLES, order: 55 },
      { icon: "tabler-sparkles", title: "Access Designer", subtitle: "Visual user access", to: { name: "access-designer" }, accessKey: PAGE_KEYS.USERS_ACCESS_DESIGNER, order: 60 },
      { icon: "tabler-shield-lock", title: "Access Management", subtitle: "Role profiles", to: { name: "permission" }, accessKey: PAGE_KEYS.USERS_PERMISSIONS, order: 61 },
    ],
    search: [
      { group: "Admin", icon: "tabler-user-plus", title: "System Users", url: { name: "roles" }, accessKey: PAGE_KEYS.USERS_ROLES, order: 10 },
      { group: "Admin", icon: "tabler-sparkles", title: "Access Designer", url: { name: "access-designer" }, accessKey: PAGE_KEYS.USERS_ACCESS_DESIGNER, order: 20 },
      { group: "Admin", icon: "tabler-shield-lock", title: "Access Management", url: { name: "permission" }, accessKey: PAGE_KEYS.USERS_PERMISSIONS, order: 21 },
    ],
  },
  {
    key: MODULE_KEYS.GUARDIANS,
    label: "Guardians",
    labelKey: "alkokh.sidebar.guardians",
    icon: "tabler-users-group",
    fallbackRoles: [Permissions.Guardians],
    nav: { order: 120, titleKey: "alkokh.sidebar.guardians", icon: "tabler-users-group" },
    pages: [
      {
        key: PAGE_KEYS.GUARDIANS_LIST,
        label: "Guardians",
        labelKey: "alkokh.sidebar.guardiansList",
        doctype: "Guardian",
        paths: ["/guardians/list"],
        pathPrefixes: ["/guardians/"],
        routeNames: ["guardians-list"],
        fallbackRoles: [Permissions.Guardians],
        nav: { titleKey: "alkokh.sidebar.guardiansList", icon: "tabler-user-heart", order: 10, to: { name: "guardians-list" } },
      },
    ],
    shortcuts: [
      { icon: "tabler-users-group", title: "Guardians", subtitle: "Customer records", to: { name: "guardians-list" }, accessKey: PAGE_KEYS.GUARDIANS_LIST, order: 50 },
    ],
    search: [
      { group: "Records", icon: "tabler-users-group", title: "Guardians", url: { name: "guardians-list" }, accessKey: PAGE_KEYS.GUARDIANS_LIST, order: 20, noData: true },
      { group: "Records", icon: "tabler-user-search", title: "Customers", url: { name: "guardians-list" }, accessKey: PAGE_KEYS.GUARDIANS_LIST, order: 30 },
    ],
  },
  {
    key: MODULE_KEYS.CUSTOMERS,
    label: "Customers",
    labelKey: "alkokh.sidebar.customers",
    icon: "tabler-user-heart",
    fallbackRoles: [Permissions.Customer, ...SALES_ACCOUNTING_ROLES],
    nav: { order: 125, titleKey: "alkokh.sidebar.customers", icon: "tabler-user-heart" },
    pages: [
      {
        key: PAGE_KEYS.CUSTOMERS_LIST,
        label: "Customers",
        labelKey: "alkokh.sidebar.customersList",
        doctype: "Customer",
        paths: ["/customers/list"],
        pathPrefixes: ["/customers/details/"],
        routeNames: ["customers-list"],
        fallbackRoles: [Permissions.Customer, ...SALES_ACCOUNTING_ROLES],
        nav: { titleKey: "alkokh.sidebar.customersList", icon: "tabler-users", order: 10, to: { name: "customers-list" } },
      },
      {
        key: PAGE_KEYS.CUSTOMER_GROUPS,
        label: "Customer Groups",
        labelKey: "alkokh.sidebar.customerGroups",
        doctype: "Customer Group",
        paths: ["/customers/groups"],
        pathPrefixes: ["/customers/groups/"],
        routeNames: ["customers-groups"],
        fallbackRoles: [Permissions.Customer, Permissions.SalesMasterManager, ...SALES_ACCOUNTING_ROLES],
        nav: { titleKey: "alkokh.sidebar.customerGroups", icon: "tabler-users-group", order: 20, to: { name: "customers-groups" } },
      },
      {
        // Revenue and customer lists per area, so managers only. Reached by URL: nav and search
        // entries are intentionally omitted. The entry is still needed so the route guard gates it.
        key: PAGE_KEYS.CUSTOMERS_TERRITORY_INSIGHTS,
        label: "Territory Insights",
        labelKey: "alkokh.territoryInsights.title",
        doctype: "Customer",
        paths: ["/customers/territory-insights"],
        routeNames: ["customers-territory-insights"],
        fallbackRoles: SALES_ACCOUNTING_ROLES,
      },
    ],
    shortcuts: [
      { icon: "tabler-user-heart", title: "Customers", subtitle: "Sales and debt hub", to: { name: "customers-list" }, accessKey: PAGE_KEYS.CUSTOMERS_LIST, order: 55 },
      { icon: "tabler-users-group", title: "Customer Groups", subtitle: "Customer group hierarchy", to: { name: "customers-groups" }, accessKey: PAGE_KEYS.CUSTOMER_GROUPS, order: 56 },
    ],
    search: [
      { group: "Records", icon: "tabler-user-heart", title: "Customers", url: { name: "customers-list" }, accessKey: PAGE_KEYS.CUSTOMERS_LIST, order: 30, noData: true },
      { group: "Records", icon: "tabler-users-group", title: "Customer Groups", url: { name: "customers-groups" }, accessKey: PAGE_KEYS.CUSTOMER_GROUPS, order: 31, noData: true },
    ],
  },
  {
    key: MODULE_KEYS.SETTINGS,
    label: "Settings",
    labelKey: "alkokh.sidebar.setting",
    icon: "tabler-settings",
    fallbackRoles: [Permissions.Setting],
    nav: { order: 130, titleKey: "alkokh.sidebar.setting", icon: "tabler-settings", singlePage: true },
    pages: [
      {
        key: PAGE_KEYS.SETTINGS,
        label: "Settings",
        labelKey: "alkokh.sidebar.setting",
        doctype: "System Settings",
        paths: ["/setting/module-settings"],
        pathPrefixes: ["/setting/"],
        routeNames: ["setting-tab"],
        fallbackRoles: [Permissions.Setting],
        nav: {
          titleKey: "alkokh.sidebar.setting",
          icon: "tabler-settings",
          order: 10,
          to: { name: "setting-tab", params: { tab: "module-settings" } },
        },
      },
    ],
    search: [
      {
        group: "Admin",
        icon: "tabler-settings",
        title: "Settings",
        url: { name: "setting-tab", params: { tab: "module-settings" } },
        accessKey: PAGE_KEYS.SETTINGS,
        order: 30,
      },
    ],
  },
  {
    key: MODULE_KEYS.WHATSAPP,
    label: "WhatsApp",
    labelKey: "alkokh.sidebar.whatsapp",
    icon: "tabler-brand-whatsapp",
    fallbackRoles: WHATSAPP_ROLES,
    nav: { order: 135, titleKey: "alkokh.sidebar.whatsapp", icon: "tabler-brand-whatsapp", singlePage: true },
    pages: [
      {
        key: PAGE_KEYS.WHATSAPP,
        label: "WhatsApp",
        labelKey: "alkokh.sidebar.whatsapp",
        doctype: "Pet App WhatsApp Account",
        paths: ["/whatsapp/live-msgs"],
        pathPrefixes: ["/whatsapp/"],
        routeNames: ["whatsapp-tab"],
        fallbackRoles: WHATSAPP_ROLES,
        nav: {
          titleKey: "alkokh.sidebar.whatsapp",
          icon: "tabler-brand-whatsapp",
          order: 10,
          to: { name: "whatsapp-tab", params: { tab: "live-msgs" } },
        },
      },
    ],
    search: [
      {
        group: "Admin",
        icon: "tabler-brand-whatsapp",
        title: "WhatsApp",
        url: { name: "whatsapp-tab", params: { tab: "live-msgs" } },
        accessKey: PAGE_KEYS.WHATSAPP,
        order: 31,
      },
    ],
  },
];
